module.exports = __webpack_public_path__ + "static/media/icomoon.2618ba2a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.ttf?l3qv7r
// module id = 2760
// module chunks = 33